define('cartware_checkout/main',[
	"require",
	"lodash",
	"lucid",
	"cartware/components/Registry",
	"json!./handles/cartware_checkout.json"
], function(
	require,
	_,
	lucidJS,
	Registry,
	Handles
) {
	var _instance = null;

	var getInstance = function() {
		if (_instance === null) {
			_instance = new Checkout();
		}

		return _instance;
	};

	function Checkout() {
		if (!(this instanceof Checkout)) {
			return getInstance();
		}

		lucidJS.EventEmitter.call(this);
		this._register = {};
	}

	Checkout.getInstance = getInstance;

	Checkout.ready = function(cb) {
		return getInstance().ready(cb);
	};

	Checkout.bootstrap = function() {
		return getInstance().bootstrap();
	};

	Checkout.prototype = _.create(new lucidJS.EventEmitter, {
		"constructor": Checkout,
		_register: null,

		bootstrap: function() {
			this.bootstrapDispatcher();
		},

		bootstrapDispatcher: function() {
			Registry().retrieve("component.dispatcher", function(dispatcher) {
				_.forEach(Handles, function(components, handle) {
					require(components, function() {
						var handleMapApply = {};
						handleMapApply[handle] = Array.prototype.slice.call(arguments, 0);

						dispatcher.applyHandles(handleMapApply);
					});
				});
			});
		},

		ready: function(cb) {
			this.bind("ready", cb);
		},

		updateProgress: function(json) {
			("progress-detail" in json.blocks) && $('col-right-opcheckout').update(json.blocks['progress-detail']);
			("progress-bar" in json.blocks) && $('opcheckout-progress-bar').update(json.blocks['progress-bar']);
		},

		register: function(key, value, graceful) {
			if (key in this._register) {
				if (graceful) return;

				throw "Registry key '" + key + "' has already been set.";
			}

			this._register[key] = value;
			this.flag("available." + key, value);


			return this;
		},

		unregister: function(key) {
			if (key in this._register) {
				delete this._register[key];
			}

			this.unflag("available." + key);

			return this;
		},

		retrieve: function(key, callback) {
			this.bind("available." + key, callback);
		}
	});

	return Checkout;
});
define('cartware_checkout', ['cartware_checkout/main'], function (main) { return main; });

